import { OfferService } from "@/generated/services/OfferService";
import { useQuery } from "@tanstack/react-query";

export function useFetchOfferById(
  offerId: number,
  memberId?: number,
  retailerId?: number,
) {
  return useQuery({
    queryKey: ["offer", offerId],
    enabled: !!offerId, // only run when offerId is valid
    queryFn: async () => {
      if (!offerId) throw new Error("Invalid offer ID");

      const response = await OfferService.getOffers1(
        offerId,
        undefined,
        retailerId,
      );

      return {
        ...response,
      };
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
}
